import { render, staticRenderFns } from "./alternativeLogin.vue?vue&type=template&id=a8cf7754&scoped=true"
import script from "./alternativeLogin.vue?vue&type=script&lang=js"
export * from "./alternativeLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cf7754",
  null
  
)

export default component.exports